module.exports = __webpack_public_path__ + "img/bc96154dddb8ff05440ef8bae9fd9dd9.png";